export default __webpack_public_path__ + "c82b93a2374164e80e5ce5c023ffd459.png";